module.exports = __webpack_public_path__ + "static/img/widget-2.b57c00a0.png";